import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { upsertFilter, removeFilter } from '../redux-state/actions/filters';
import { number } from 'prop-types';
import { IAppState } from '../classes/app';
import { goToPage } from '../redux-state/actions/listing';

const maxNumberOfPages: number = 5;

interface IExternalProps { //pass into this component listItemComponent={props 

    thisPageNumber: number;
    isActive: boolean;
}

interface StateToProps {

}

interface DispatchToProps {
    updateFilter: (query: string) => void;
}

type FiltersProps = IExternalProps & StateToProps & DispatchToProps;

export class PageButton extends React.Component<FiltersProps> {

    selectPage(evt: React.ChangeEvent<HTMLLIElement>) {
        this.updateValue(null);
        this.scrollToTop();
    }

    protected scrollToTop() {
        const additionalMargin = 84;
        let bodyContainerPos = document.body.getBoundingClientRect().top;
        let headerContainer = document.querySelector('#siteHeader');
        let headerContainerPos = headerContainer.getBoundingClientRect().top;
        let searchContainer = document.querySelector('.adage-search');
        let searchContainerPos = searchContainer.getBoundingClientRect().top;
        let scrollToPos = searchContainerPos - bodyContainerPos + headerContainerPos - additionalMargin;

        window.scrollTo({
            top: scrollToPos
        });
    }

    protected updateValue(evt) {
        const updatedValue = this.props.thisPageNumber;
        this.props.updateFilter(updatedValue.toString());
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <li >
                <button className={this.props.isActive ? "btn active" : "btn"} onClick={this.selectPage.bind(this)}>
                    {this.props.thisPageNumber}
                </button>
            </li>
        );
    }
}


export function mapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    return {
        thisPageNumber: ownProps.thisPageNumber
    }
}

const name: string = "page";

export function mapDispatchToProps(dispatch: Dispatch, ownProps: IExternalProps): DispatchToProps {
    return {
        updateFilter: (query: string) => {
       
            dispatch(upsertFilter(name, query) as any);
            dispatch(goToPage(ownProps.thisPageNumber));
        }
    }
}

export const ConnectedPageButton = connect(mapStateToProps, mapDispatchToProps)(PageButton);